module.exports = __webpack_public_path__ + "static/img/3.b60c80f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/3.png
// module id = jm4+
// module chunks = 1